/** `snippets/product-card.liquid` — region-based availability badges on product cards. */

const REGION_LS_KEY = 'wyld_us_state'
const CARD_SELECTOR = '[data-product-card]'
const REGION_PROMPT_SELECTOR = '[data-product-card-region-prompt]'
const ADD_BTN_SELECTOR = '[data-product-card-add]'
const REGION_UNAVAILABLE_CLASS = 'product-card-region-unavailable'
const CARD_VIDEO_SELECTOR = '[data-card-video]'
const CARD_VIDEO_BOUND_ATTR = 'data-card-video-bound'

function parseJsonAttr(el, attr) {
  const raw = el.getAttribute(attr)
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function isAvailableInState(includedStates, state) {
  if (includedStates.length === 0) return true
  return includedStates.includes(state)
}

function isSoldOut(addBtn) {
  return addBtn?.dataset.available === 'false'
}

function applyCardAvailability(card, state) {
  const prompt = card.querySelector(REGION_PROMPT_SELECTOR)
  const addBtn = card.querySelector(ADD_BTN_SELECTOR)

  if (!state) {
    if (prompt) prompt.hidden = false
    card.classList.remove(REGION_UNAVAILABLE_CLASS)
    if (addBtn) addBtn.disabled = isSoldOut(addBtn)
    return
  }

  if (prompt) prompt.hidden = true

  const included = parseJsonAttr(card, 'data-included-states')
  const available = isAvailableInState(included, state)

  // Region-unavailable cards show "Not available for shipping" and stay
  // disabled; the submit guard below is a second line of defense. Sold-out
  // also stays disabled.
  card.classList.toggle(REGION_UNAVAILABLE_CLASS, !available)
  if (addBtn) addBtn.disabled = isSoldOut(addBtn) || !available
}

function filterAllCards() {
  let state = null
  try {
    state = localStorage.getItem(REGION_LS_KEY)
  } catch {
    /* private mode */
  }
  document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
    applyCardAvailability(card, state)
  })
}

// Hover-to-play card videos. The card renders a muted, looping
// `<video data-card-video>` overlay (see product-card.liquid) that should only
// play while the card is hovered/focused, mirroring the image hover cross-fade.
// Only wire this up on pointer devices that can hover — on touch devices the
// overlay stays hidden via CSS, so there is nothing to play.
function bindCardVideos() {
  if (!window.matchMedia('(hover: hover)').matches) return

  document.querySelectorAll(CARD_VIDEO_SELECTOR).forEach((video) => {
    if (video.getAttribute(CARD_VIDEO_BOUND_ATTR) === 'true') return
    video.setAttribute(CARD_VIDEO_BOUND_ATTR, 'true')

    const card = video.closest(CARD_SELECTOR)
    if (!card) return

    const play = () => {
      const playback = video.play()
      if (playback && typeof playback.catch === 'function') {
        playback.catch(() => {})
      }
    }
    const stop = () => {
      video.pause()
      try {
        video.currentTime = 0
      } catch {
        /* resetting before metadata loads can throw; safe to ignore */
      }
    }

    card.addEventListener('pointerenter', play)
    card.addEventListener('pointerleave', stop)
    // Keyboard users tabbing to the card link should also preview the video.
    card.addEventListener('focusin', play)
    card.addEventListener('focusout', stop)
  })
}

function init() {
  filterAllCards()
  bindCardVideos()

  document.addEventListener('theme:region:state-changed', filterAllCards)
  document.addEventListener('theme:cards:appended', filterAllCards)
  document.addEventListener('theme:cards:appended', bindCardVideos)

  // Block add-to-cart for region-unavailable cards. Capture phase + immediate
  // stop runs before the global cart submit handler so the add never fires.
  document.addEventListener(
    'submit',
    (event) => {
      const card = event.target?.closest?.(CARD_SELECTOR)
      if (card?.classList.contains(REGION_UNAVAILABLE_CLASS)) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
    },
    true,
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
